{
  "placeholder": "Search place",
  "help": "What you can search for",
  "helpText": "A place name, or coordinates in any of these formats:",
  "clear": "Clear search",
  "nothingFound": "Nothing found",
  "plusCodeNear": "Plus Code near {{place}}",
  "plusCodeNearCentre": "Plus Code near map centre",
  "format": {
    "mgrs": "MGRS",
    "mgrsPolar": "MGRS (polar)",
    "utm": "UTM",
    "plusCode": "Plus Code",
    "decimal": "Decimal degrees",
    "dms": "Degrees"
  },
  "errors": {
    "service": "Search service error ({{status}})"
  }
}
